export const promoBannerStyles = {
  root: 'w-full rounded-lg border border-brand-700/20 overflow-hidden',
  inner:
    'mx-auto flex max-w-7xl flex-col gap-4 px-4 py-6 sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8',
  text: 'flex flex-col gap-1',
  title: 'font-heading text-heading-md sm:text-heading-lg',
  description: 'font-sans text-sm sm:text-md opacity-90',
  variant: {
    dark: 'bg-brand-950 text-brand-100',
    cyan: 'bg-brand-600 text-brand-100',
    light: 'bg-brand-100 text-brand-950',
  },
} as const;
